module.exports = __webpack_public_path__ + "media/images/athletes/1580-8ae2189192d2a90d8a9c92d7eb2208b2.png";